var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSliderPlusSign = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8134_510599",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 9.33398C16.7365 9.33398 17.3335 9.93094 17.3335 10.6673V14.6673H21.3335C22.0699 14.6673 22.6668 15.2643 22.6668 16.0007C22.6668 16.737 22.0699 17.334 21.3335 17.334H17.3335V21.334C17.3335 22.0704 16.7365 22.6673 16.0002 22.6673C15.2638 22.6673 14.6668 22.0704 14.6668 21.334V17.334H10.6668C9.93045 17.334 9.3335 16.737 9.3335 16.0007C9.3335 15.2643 9.93045 14.6673 10.6668 14.6673H14.6668V10.6673C14.6668 9.93094 15.2638 9.33398 16.0002 9.33398Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8134_510599)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6888 -25.3322C14.9654 -26.0692 17.0271 -26.0739 18.3116 -25.3322L50.6392 -6.66787C51.9158 -5.93085 52.9506 -4.14769 52.9506 -2.66438V34.6643C52.9506 36.1383 51.9238 37.9261 50.6392 38.6678L18.3116 57.3321C17.0351 58.0692 14.9734 58.0738 13.6888 57.3321L-18.6388 38.6678C-19.9153 37.9308 -20.9502 36.1476 -20.9502 34.6643V-2.66438C-20.9502 -4.13843 -19.9234 -5.92622 -18.6388 -6.66787L13.6888 -25.3322Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSliderPlusSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slider-plus-sign.b66be7d34dc329eeca6cf84e2cb8b2f9.svg";